import { render } from "./PsRouteLink.vue?vue&type=template&id=bd0d3c66&ts=true"
import script from "./PsRouteLink.vue?vue&type=script&lang=ts"
export * from "./PsRouteLink.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jstechno-26/projects/Barting-Coin/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__